export const COLORES_ALERTA = [
  '#dc2626',
  '#ea580c',
  '#ca8a04',
  '#0d9488',
  '#2563eb',
  '#7c3aed',
];
